// menu.component.ts
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { STUDIO_MENU_LABELS, CUSTOMER_MENU_LABELS, AR_MENU_LABELS } from '../../constants/core.constant';
import { Subscription } from 'rxjs';
import { IconsService } from 'src/app/shared/services/icons/icons.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit,OnDestroy {
  @Input() sticky: boolean = false;
  @Input() portalType: any;
  userTypeId: number;
  permissionsData: any;
  studiolabels = STUDIO_MENU_LABELS;
  customerlabels = CUSTOMER_MENU_LABELS;
  arlabels = AR_MENU_LABELS;
  userRole: any;
  showAlert: boolean;  // To store the current value of showAlert
  private alertSubscription: Subscription;

  constructor(private readonly iconService: IconsService) { }

  ngOnInit(): void {
      // Subscribe to the showAlert observable
      this.alertSubscription = this.iconService.showAlert$.subscribe(
        (status: boolean) => {
          this.showAlert = status;
        }
      );
    const userProfile = JSON.parse(localStorage.getItem('user-profile'));
    this.permissionsData = { ...userProfile.roleAssigned };
    this.userTypeId = userProfile?.userTypeId;
    this.userRole = userProfile?.roles;
    
    if (this.userTypeId === 1) {
      this.portalType = 'customer';
    } else if (this.userTypeId === 2) {
      if (Array.isArray(this.userRole) && this.userRole.includes('A/R')) {
        this.portalType = 'ar';
      } else {
        this.portalType = 'studio';
      }
    }
  }

  /**
 * ngOnDestroy() - Lifecycle hook that is called when the component is about to be destroyed.
 */
  ngOnDestroy(): void {
    if (this.alertSubscription) {
      this.alertSubscription.unsubscribe();  // Clean up the subscription
    }
  }
}